module.exports = __webpack_public_path__ + "static/media/view3.03447a05.jpg";